import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToPercentPipe'
})
export class NumberToPercentPipe implements PipeTransform {
	transform(value: any): string {
		if (!isNaN(value)) {
			return Math.round((value * 100) / 100) + '%';
		}

		return '';
	}
}
